import { TextFieldFormsy } from '@fuse/core/formsy';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Formsy from 'formsy-react';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { submitLogin } from 'app/auth/store/loginSlice';
import GoogleLoginButton from './GoogleLoginButton';

const useStyles = makeStyles(theme => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.7rem'
  },
  systemButton: {
    width: '250px',
    maxHeight: '46px !important',
    backgroundColor: '#ededed !important',
    borderRadius: '45px',
    fontSize: '13px !important',
    fontWeight: '700 !important',
    fontFamily: 'Arial, sans-serif !important',
    color: '#2f2f2f !important',
    textTransform: 'capitalize',
    padding: '4px 19px 3px 4px !important',
    justifyContent: 'space-between',
    border: 'none !important',
    boxShadow: 'none !important',

    '&:hover': {
      backgroundColor: '#c7c7c7 !important'
    },

    '@media screen and (max-width: 959px)': {
      width: '300px',
      paddingRight: '45px !important'
    }
  },
  submitButton: {
    width: '250px',
    height: '46px !important',
    backgroundColor: '#ededed !important',
    color: '#000 !important',
    borderRadius: '45px',
    fontSize: '13px !important',
    fontWeight: '700 !important',
    fontFamily: 'Arial, sans-serif !important',
    textTransform: 'capitalize',
    border: 'none !important',
    boxShadow: 'none !important',

    '&:hover': {
      backgroundColor: '#c7c7c7 !important'
    },

    '@media screen and (max-width: 959px)': {
      width: '300px',
      paddingRight: '45px !important'
    }
  },
  optionButtons: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem'
  },
  alignItems: 'center',
  /* STYLES FOR TEXTFIELD */
  root: {
    '& .MuiFilledInput-root': {
      backgroundColor: '#ededed',
      borderRadius: '0 !important',
      height: '46px !important'
    },
    '& .MuiInputLabel-root': {
      fontSize: '12px !important'
    },
    '& .MuiInputBase-input': {
      height: '9px !important'
    },
    '& .MuiInputBase-input:-webkit-autofill': {
      '-webkit-box-shadow': '0 0 0 1000px #ededed inset !important',
      'box-shadow': '0 0 0 1000px #ededed inset !important'
    },
    '& .Mui-focused': {
      backgroundColor: '#ECECEC',
      '&.MuiFormHelperText-root.Mui-error': {
        backgroundColor: '#161616'
      }
    }
  },
  inputField: {
    width: '250px',
    borderColor: '#b8b8b8 !important',

    '@media screen and (max-width: 959px)': {
      width: '300px'
    }
  },
  title: {
    fontSize: '11px',
    fontWeight: 'bold'
  },
  btn: {
    fontSize: '12px !important',
    transition: 'color 0.2s ease, text-decoration-color 0.2s ease',

    '&:hover': {
      backgroundColor: 'transparent !important',
      color: '#125ea8',
      textDecoration: 'underline'
    }
  },
  formWrapper: {
    overflow: 'hidden',
    maxHeight: 0,
    transition: 'max-height 1.2s ease',
    width: '100%'
  },
  formWrapperVisible: {
    maxHeight: '500px'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '1rem',
    width: '100%',
    opacity: 0,
    transition: 'opacity 0.5s ease'
  },
  formVisible: {
    opacity: 1,
    transitionDelay: '0.35s'
  },
  emailField: {
    marginBottom: '0.5rem'
  },
  passwordField: {
    marginBottom: '0.5rem'
  },
  forgotRow: {
    display: 'flex',
    justifyContent: 'flex-start'
  }
}));

function JWTLoginTab({ onShowCredentials }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const login = useSelector(({ auth }) => auth.login);

  const [isFormValid, setIsFormValid] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showCredentialsLogin, setShowCredentialsLogin] = useState(false);

  const formRef = useRef(null);

  useEffect(() => {
    if (formRef.current && login.error && (login.error.email || login.error.password)) {
      formRef.current.updateInputsWithError({
        ...login.error
      });
      disableButton();
    }
  }, [login.error, showCredentialsLogin]);

  function disableButton() {
    setIsFormValid(false);
  }

  function enableButton() {
    setIsFormValid(true);
  }

  function handleSubmit(model) {
    dispatch(submitLogin(model));
  }

  return (
    <div className={classes.container}>
      <h4 className={classes.title}>Sign in with</h4>

      <div className={classes.optionButtons}>
        {process.env.NODE_ENV !== 'production' && <GoogleLoginButton buttonText="Company Gmail Account" />}
        {!showCredentialsLogin && (
          <Button
            type="button"
            variant="outlined"
            className={classes.systemButton}
            onClick={() => {
              setShowCredentialsLogin(true);
              if (onShowCredentials) onShowCredentials();
            }}
          >
            <svg
              width="39"
              height="39"
              viewBox="0 0 39 39"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginRight: '8px' }}
            >
              <path
                d="M37.1381 19.319C37.1381 29.1601 29.1601 37.1381 19.319 37.1381C9.47785 37.1381 1.5 29.1601 1.5 19.319C1.5 9.47785 9.47785 1.5 19.319 1.5C29.1601 1.5 37.1381 9.47785 37.1381 19.319Z"
                stroke="#333333"
                strokeWidth="3"
              />
              <path
                d="M24.2193 14.8642C24.2193 17.5706 22.0254 19.7645 19.319 19.7645C16.6127 19.7645 14.4188 17.5706 14.4188 14.8642C14.4188 12.1579 16.6127 9.96399 19.319 9.96399C22.0254 9.96399 24.2193 12.1579 24.2193 14.8642Z"
                stroke="#333333"
                strokeWidth="3"
              />
              <path
                d="M7.73666 31.7925L8.73524 30.045C10.3215 27.2691 13.2736 25.5558 16.4709 25.5558H22.1672C25.3644 25.5558 28.3165 27.2691 29.9028 30.045L30.9013 31.7925"
                stroke="#333333"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            System username/password
          </Button>
        )}
      </div>

      <div className={clsx(classes.formWrapper, showCredentialsLogin && classes.formWrapperVisible)}>
        <Formsy
          onValidSubmit={handleSubmit}
          onValid={enableButton}
          onInvalid={disableButton}
          autoComplete="off"
          ref={formRef}
          className={clsx(classes.form, showCredentialsLogin && classes.formVisible)}
        >
          <TextFieldFormsy
            className={clsx(classes.root, classes.inputField, classes.emailField, 'border border-solid')}
            type="text"
            name="email"
            label="Email"
            value=""
            validations={{
              isEmail: true
            }}
            validationErrors={{
              isEmail: 'This is not a valid email'
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Icon className="text-20">email</Icon>
                </InputAdornment>
              )
            }}
            variant="filled"
            required
          />

          <TextFieldFormsy
            className={clsx(classes.root, classes.inputField, classes.passwordField, 'border border-solid')}
            type="password"
            name="password"
            label="Password"
            value=""
            InputProps={{
              type: showPassword ? 'text' : 'password',
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(!showPassword)} className="m-0 p-1">
                    <Icon className="text-20 text-black">{showPassword ? 'visibility' : 'visibility_off'}</Icon>
                  </IconButton>
                </InputAdornment>
              )
            }}
            variant="filled"
            required
            color="primary"
          />
          <div className={classes.forgotRow}>
            <Button
              type="button"
              className={clsx(classes.btn, 'text-blue-700 capitalize pl-0')}
              onClick={() => history.push('/forgot-password')}
            >
              Forgot password?
            </Button>
          </div>
          <Button
            type="submit"
            variant="contained"
            aria-label="LOG IN"
            disabled={!isFormValid}
            value="legacy"
            className={clsx(classes.submitButton, 'mx-auto normal-case')}
          >
            Sign in
          </Button>
        </Formsy>
      </div>
    </div>
  );
}

export default JWTLoginTab;
